import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
function loggedIn(to, from, next) {
  const token = localStorage.getItem('token');

  if (token && to.name === 'login') {
    next({ name: 'dashboard' });
  } else if (!token && to.name !== 'login') {
    next({ name: 'login' }); 
  } else {
    next(); 
  }
}

function hasPayrollAccess(to, from, next) {
  const token = localStorage.getItem('token');
  const payrollAccess = JSON.parse(localStorage.getItem('payroll_access'));
  const userTypeId = JSON.parse(localStorage.getItem('user'));

  if (!token) {
    next({ name: 'login' });
    return;
  }

  if (userTypeId[0].user_type_id == 0) {
    next();
    return;
  }

  const routeAccessParams = {
    'Deduction Type': { parent_module: 'Configuration', child_module: 'Deduction Type', sub_child_module: null },
    'Payroll Rate': { parent_module: 'Configuration', child_module: 'Payroll Rate', sub_child_module: null },
    'Payroll Variable': { parent_module: 'Configuration', child_module: 'Payroll Variable', sub_child_module: null },
    'Tax': { parent_module: 'Configuration', child_module: 'Government', sub_child_module: 'Tax' },
    'PhilHealth': { parent_module: 'Configuration', child_module: 'Government', sub_child_module: 'PhilHealth' },
    'SSS': { parent_module: 'Configuration', child_module: 'Government', sub_child_module: 'SSS' },
    'PagIbig': { parent_module: 'Configuration', child_module: 'Government', sub_child_module: 'Pag-Ibig' },
    'DTR': { parent_module: 'Payroll', child_module: 'Payroll Register', sub_child_module: null },
    'Details': { parent_module: 'Payroll', child_module: 'Payroll Register', sub_child_module: null },
    'Payroll Register': { parent_module: 'Payroll', child_module: 'Payroll Register', sub_child_module: null },
    'PayrollSummary': { parent_module: 'Payroll', child_module: 'Payroll Register', sub_child_module: null },
    'EditPayrollSummary': { parent_module: 'Payroll', child_module: 'Payroll Register', sub_child_module: null },
    'Deduction and Addition': { parent_module: 'Payroll', child_module: 'Deduction and Addition', sub_child_module: null },
    'Employee Last Pay': { parent_module: 'Payroll', child_module: `Employee's Last Pay`, sub_child_module: null },
    'Edit Employee Last Pay': { parent_module: 'Payroll', child_module: `Employee's Last Pay`, sub_child_module: null },
    'Thirteenth Month Pay': { parent_module: 'Payroll', child_module: 'Thirteenth Month Pay', sub_child_module: null },
    'Thirteenth Month Pay Details': { parent_module: 'Payroll', child_module: 'Thirteenth Month Pay', sub_child_module: null },
    'Thirteenth Month Pay Summary': { parent_module: 'Payroll', child_module: 'Thirteenth Month Pay', sub_child_module: null },
    'Payroll Register Report': { parent_module: 'Reports', child_module: 'Payroll Reports', sub_child_module: 'Payroll Register Report' },
    'Payroll Register History Per Employee Report': { parent_module: 'Reports', child_module: 'Payroll Reports', sub_child_module: 'Payroll Register History Per Employee Report' },
    'Deduction Actual Report': { parent_module: 'Reports', child_module: 'Payroll Reports', sub_child_module: 'Deduction Report' },
    'Addition Report': { parent_module: 'Reports', child_module: 'Payroll Reports', sub_child_module: 'Addition Report' },
    'PhilHealth Report': { parent_module: 'Reports', child_module: 'Government Reports', sub_child_module: 'PHIC Report' },
    'Pag-Ibig Report': { parent_module: 'Reports', child_module: 'Government Reports', sub_child_module: 'HDMF Report' },
    'SSS Report': { parent_module: 'Reports', child_module: 'Government Reports', sub_child_module: 'SSS Report' },
    'Tax Summary Report': { parent_module: 'Reports', child_module: 'Government Reports', sub_child_module: 'Tax Summary Report' },
    'BIR 2316 Report': { parent_module: 'Reports', child_module: 'Government Reports', sub_child_module: 'BIR 2316 Report' },
    'Employee Information Report': { parent_module: 'Reports', child_module: 'Other', sub_child_module: 'Employee Information Report' },
    'Overtime Report': { parent_module: 'Reports', child_module: 'Other', sub_child_module: 'Overtime Report' },
    'Allowance Report': { parent_module: 'Reports', child_module: 'Other', sub_child_module: 'Allowance Report' },
    'Payroll Data for Bank': { parent_module: 'Reports', child_module: 'Other', sub_child_module: 'Payroll Data for Bank' },
    'Thirteenth Month Report': { parent_module: 'Reports', child_module: 'Other', sub_child_module: 'Thirteenth Month Report' },
    'Alphalist Payroll Journal Monthly Government Report': { parent_module: 'Reports', child_module: 'Payroll Reports', sub_child_module: 'Alphalist Payroll Journal Monthly Government Report' },
  };

  const routeParams = routeAccessParams[to.name];

  if (!routeParams) {
    next({ name: 'dashboard' });
    return;
  }

  // Check for access
  const moduleAccess = payrollAccess.find(
    (access) =>
      access.parent_module === routeParams.parent_module &&
      access.child_module === routeParams.child_module && 
      access.sub_child_module === routeParams.sub_child_module &&
      access.allaccess === 1
  );

  if (moduleAccess) {
    next(); // Allow access
  } else {
    next({ name: 'dashboard' });
  }
}

function hasHRISAccess(to, from, next) {
  const token = localStorage.getItem('token');
  const hrisAccess = JSON.parse(localStorage.getItem('hris_access'));
  const userTypeId = JSON.parse(localStorage.getItem('user'));

  if (!token) {
    next({ name: 'login' });
    return;
  }

  if (userTypeId[0].user_type_id == 0) {
    next();
    return;
  }

  const routeAccessParams = {
    'HRIS Dashboard': { parent_module: 'Dashboard', child_module: null },
    'Applicant': { parent_module: 'Applicant', child_module: null },
    'Employee': { parent_module: 'Employee', child_module: null },
    'EmployeeProfile': { parent_module: 'Employee', child_module: null },
    'PersonalInformation': { parent_module: 'Employee', child_module: null },
    'SelectedPersonalInformation': { parent_module: 'Employee', child_module: null },
    'Memo Records': { parent_module: 'Memo Records', child_module: null },
    'Assets': { parent_module: 'Assets', child_module: null },
    'Company': { parent_module: 'Settings', child_module: 'Company' },
    'PayrollGroup': { parent_module: 'Settings', child_module: 'Payroll Group'},
    'RateCategory': { parent_module: 'Settings', child_module: 'Rate Category'},
    'Leave': { parent_module: 'Settings', child_module: 'Leave'},
    'Approver': { parent_module: 'Settings', child_module: 'Approver'},
    'Schedule': { parent_module: 'Settings', child_module: 'Schedule'},
    'UserType': { parent_module: 'Settings', child_module: 'User Type'},
    'UserModule': { parent_module: 'Settings', child_module: 'User Module'},
    'UserAccount': { parent_module: 'Settings', child_module: 'User Account'},
    'EmployeeUpload': { parent_module: 'Settings', child_module: 'Upload Employee'},
    'Holidays': { parent_module: 'Settings', child_module: 'Holidays'},
    'GeoFencing': { parent_module: 'Settings', child_module: 'Geo Fencing'},
  };

  const routeParams = routeAccessParams[to.name];

  if (!routeParams) {
    next({ name: 'dashboard' });
    return;
  }

  // Check for access
  const moduleAccess = hrisAccess.find(
    (access) =>
      access.parent_module === routeParams.parent_module &&
      access.child_module === routeParams.child_module &&
      access.allaccess === 1
  );

  if (moduleAccess) {
    next(); // Allow access
  } else {
    next({ name: 'dashboard' });
  }
}

function hasTimekeepingAccess(to, from, next) {
  const token = localStorage.getItem('token');
  const timekeepingAccess = JSON.parse(localStorage.getItem('timekeeping_access'));
  const userTypeId = JSON.parse(localStorage.getItem('user'));

  if (!token) {
    next({ name: 'login' });
    return;
  }

  if (userTypeId[0].user_type_id == 0) {
    next();
    return;
  }

  const routeAccessParams = {
    'Import/Download Biometrics': { parent_module: 'Admin Settings', child_module: 'Import/Download Biometrics' },
    'Time Records': { parent_module: 'Employee Forms', child_module: 'Time Records' },
    'Overtime Records': { parent_module: 'Employee Forms', child_module: 'Overtime Records' },
    'Leave Records': { parent_module: 'Employee Forms', child_module: 'Leave Records' },
    'Team Status': { parent_module: 'Employee Forms', child_module: 'Team Status' },
    'Payslip': { parent_module: 'Employee Forms', child_module: 'Payslip' },
    'Attendance Report': { parent_module: 'Reports', child_module: 'Attendance Report'},
    'Absences Report': { parent_module: 'Reports', child_module: 'Absences Report'},
    'Leave Report': { parent_module: 'Reports', child_module: 'Leave Report'},
    'Overtime Report': { parent_module: 'Reports', child_module: 'Overtime Report'},
    'Leave Balances Report': { parent_module: 'Reports', child_module: 'Leave Balances Report'},
    'Punch Alteration Report': { parent_module: 'Reports', child_module: 'Punch Alteration Report'},
    'Frequency of Tardiness Report': { parent_module: 'Reports', child_module: 'Frequency of Tardiness'},
    'Tardiness Report': { parent_module: 'Reports', child_module: 'Tardiness Report'},
    'Summary of Leaves': { parent_module: 'Reports', child_module: 'Summary of Leaves'},
    'Summary of Tardiness': { parent_module: 'Reports', child_module: 'Summary of Tardiness'},
    'Pending Approval': { parent_module: 'Approvals', child_module: 'Pending Approval'},
    'Alteration History': { parent_module: 'Approvals', child_module: 'Alteration History'},
    'Overtime History': { parent_module: 'Approvals', child_module: 'Overtime History'},
    'Leave History': { parent_module: 'Approvals', child_module: 'Leave History'},
    'Punch Alteration Records': { parent_module: 'Employee Forms', child_module: 'Time Records'},
  };

  const routeParams = routeAccessParams[to.name];

  if (!routeParams) {
    next({ name: 'dashboard' });
    return;
  }

  // Check for access
  const moduleAccess = timekeepingAccess.find(
    (access) =>
      access.parent_module === routeParams.parent_module &&
      access.child_module === routeParams.child_module &&
      access.allaccess === 1
  );

  if (moduleAccess) {
    next(); // Allow access
  } else {
    next({ name: 'dashboard' });
  }
}


const routes = [
  {
    path: '/',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/CONSUMER/LoginPage.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/CONSUMER/RegisterPage.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/CONSUMER/PolicyPage.vue')
  },
  {
    path: '/faqs-question',
    name: 'faqs-question',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/CONSUMER/FAQsQuestion.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/CONSUMER/DashboardPage.vue'),
    beforeEnter: loggedIn
  },

  //PAYROLL
  {
    path: '/payroll/dashboard',
    name: 'Payroll Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll dashboard" */ '../views/PAYROLL/DashboardPage.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/payroll/deduction-type',
    name: 'Deduction Type',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "deduction" */ '../views/PAYROLL/Configuration/DeductionType.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-rate',
    name: 'Payroll Rate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-rate" */ '../views/PAYROLL/Configuration/PayrollRate.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-variable',
    name: 'Payroll Variable',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-variables" */ '../views/PAYROLL/Configuration/PayrollVariables.vue'),
    beforeEnter: hasPayrollAccess
  },
  // {
  //   path: '/payroll/holidays',
  //   name: 'Holiday',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "holiday" */ '../views/PAYROLL/Configuration/HolidayPage.vue')
  // },
  {
    path: '/payroll/user-type',
    name: 'User Type',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "user-type" */ '../views/PAYROLL/Configuration/UserType.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/tax',
    name: 'Tax',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tax" */ '../views/PAYROLL/Configuration/Government/TaxPage.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/philhealth',
    name: 'PhilHealth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "philhealth" */ '../views/PAYROLL/Configuration/Government/PhilhealthPage.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/sss',
    name: 'SSS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "sss" */ '../views/PAYROLL/Configuration/Government/SSSPage.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/pag-ibig',
    name: 'PagIbig',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pagibig" */ '../views/PAYROLL/Configuration/Government/PagIbigPage.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-register',
    name: 'Payroll Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-register" */ '../views/PAYROLL/Payroll/PayrollRegister.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/edit-employee-last-pay/:companyID',
    name: 'Edit Employee Last Pay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "edit-employee-last-pay" */ '../views/PAYROLL/Payroll/EmployeeLastPay/edit_lastpay.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-register/dtr/:registerNumber',
    name: 'DTR',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dtr" */ '../views/PAYROLL/Payroll/PayrollRegister/dtrPage.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-register/details/:registerNumber',
    name: 'Details',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "details" */ '../views/PAYROLL/Payroll/PayrollRegister/detailPage.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-summary/:registerNumber/:companyID',
    name: 'PayrollSummary',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employee-summary" */ '../views/PAYROLL/Payroll/PayrollRegister/employeeSummary.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/edit-payroll-summary/:registerNumber/:companyID',
    name: 'EditPayrollSummary',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "edit-payroll-summary" */ '../views/PAYROLL/Payroll/PayrollRegister/editEmployeeSummary.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/deduction-and-addition',
    name: 'Deduction and Addition',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "deductions-and-additions" */ '../views/PAYROLL/Payroll/DeductionAddition.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/employees-last-pay',
    name: 'Employee Last Pay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employee-last-pay" */ '../views/PAYROLL/Payroll/EmployeeLastPay.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/thirteenth-month-pay',
    name: 'Thirteenth Month Pay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thirteenth-month-pay" */ '../views/PAYROLL/Payroll/13thMonthPay.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/thirteeth-month-pay/details/:registerNumber',
    name: 'Thirteenth Month Pay Details',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thirteenth-month-pay-details" */ '../views/PAYROLL/Payroll/13thMonthRegister/details_page.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/thirteenth-month-pay-summary/:registerNumber/:companyID',
    name: 'Thirteenth Month Pay Summary',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thirteenth-month-pay-employee-summary" */ '../views/PAYROLL/Payroll/13thMonthRegister/13thmonth_emp_summary.vue'),
    props: true,
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-register-report',
    name: 'Payroll Register Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-register-report" */ '../views/PAYROLL/Reports/PayrollReports/PayrollRegisterReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-register-history-per-employee-report',
    name: 'Payroll Register History Per Employee Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-register-histpry-per-employee-report" */ '../views/PAYROLL/Reports/PayrollReports/PayrollRegisterHistoryPerEmployeeReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/alphalist-payroll-journal-monthly-government-report',
    name: 'Alphalist Payroll Journal Monthly Government Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "alphalist-payroll-journal-report" */ '../views/PAYROLL/Reports/PayrollReports/AlphalistPayroll.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/deduction-report',
    name: 'Deduction Actual Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "deduction-actual-report" */ '../views/PAYROLL/Reports/PayrollReports/DeductionReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/addition-report',
    name: 'Addition Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "addition-actual-report" */ '../views/PAYROLL/Reports/PayrollReports/AdditionReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  // {
  //   path: '/payroll/addition-summary-report',
  //   name: 'Addition Summary Report',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "addition-actual-report" */ '../views/PAYROLL/Reports/PayrollReports/AdditionSummaryReport.vue'),
  //   beforeEnter: hasPayrollAccess
  // },
  // {
  //   path: '/payroll/deduction-summary-report',
  //   name: 'Deduction Summary Report',
  //   component: () => import(/* webpackChunkName: "addition-actual-report" */ '../views/PAYROLL/Reports/PayrollReports/DeductionSummaryReport.vue'),
  //   beforeEnter: hasPayrollAccess
  // },
  {
    path: '/payroll/thirteenth-month-report',
    name: 'Thirteenth Month Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thirteenth-month-report" */ '../views/PAYROLL/Reports/PayrollReports/13thMonthReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/phic-report',
    name: 'PhilHealth Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "philhealth-report" */ '../views/PAYROLL/Reports/GovernmentReports/PhilHealthReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/hdmf-report',
    name: 'Pag-Ibig Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pag-ibig-report" */ '../views/PAYROLL/Reports/GovernmentReports/PagIbigReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/sss-report',
    name: 'SSS Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "sss-report" */ '../views/PAYROLL/Reports/GovernmentReports/SSSReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/tax-summary-report',
    name: 'Tax Summary Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tax-report" */ '../views/PAYROLL/Reports/GovernmentReports/TaxSummaryReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/bir-2316-report',
    name: 'BIR 2316 Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "bir-report" */ '../views/PAYROLL/Reports/GovernmentReports/BIRReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/employee-information-report',
    name: 'Employee Information Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employee-information-report" */ '../views/PAYROLL/Reports/Others/EmployeeInformationReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/overtime-report',
    name: 'Overtime Report', //duplicated name
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "overtime-summary-report" */ '../views/PAYROLL/Reports/Others/OvertimeReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/allowance-report',
    name: 'Allowance Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "allowance-report" */ '../views/PAYROLL/Reports/Others/AllowanceReport.vue'),
    beforeEnter: hasPayrollAccess
  },
  {
    path: '/payroll/payroll-data-for-bank',
    name: 'Payroll Data for Bank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payroll-data-for-bank" */ '../views/PAYROLL/Reports/Others/MetroBankData.vue'),
    beforeEnter: hasPayrollAccess
  },
  



  //HRIS
  {
    path: '/hris/dashboard',
    name: 'HRIS Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/HRIS/DashboardPage.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/employee',
    name: 'Employee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/HRIS/EmployeePage.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/applicant',
    name: 'Applicant',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "applicant" */ '../views/HRIS/ApplicantPage.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/memo-records',
    name: 'Memo Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "memo-records" */ '../views/HRIS/MemoPage.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/hr-records',
    name: 'HR Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "hr-records" */ '../views/HRIS/HRRecords.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/assets',
    name: 'Assets',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "assets" */ '../views/HRIS/AssetsPage.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "settings" */ '../views/HRIS/SettingPage.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/hris/settings/company',
    name: 'Company',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "company" */ '../views/HRIS/Settings/company.vue'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/payrollgroup',
    name: 'PayrollGroup',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payrollgroup" */ '../views/HRIS/Settings/payrollgroup'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/employee/employee_profile/:id/:company_id',
    name: 'EmployeeProfile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employeeprofile" */ '../views/HRIS/Employee/employee_profile'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/employee/employee_personal_information/:id/:company_id',
    name: 'PersonalInformation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "personalinformation" */ '../views/HRIS/Employee/employee_personal_information'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/employee/selected_employee_personal_information/:employee_type',
    name: 'SelectedPersonalInformation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "selectedpersonalinformation" */ '../views/HRIS/Employee/generate_selected_pdf'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/ratecategory',
    name: 'RateCategory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ratecategory" */ '../views/HRIS/Settings/ratecategory'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/schedule',
    name: 'Schedule',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "schedule" */ '../views/HRIS/Settings/schedule'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/leave',
    name: 'Leave',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "leave" */ '../views/HRIS/Settings/leave'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/memo/notice_explain',
    name: 'Notice Explain',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "notice explain" */ '../views/HRIS/Memo/notice_explain'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/memo/notice_decision',
    name: 'Notice Decision',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "notice decision" */ '../views/HRIS/Memo/notice_decision'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/approver',
    name: 'Approver',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "approver" */ '../views/HRIS/Settings/approver_setting'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/usertype',
    name: 'UserType',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "usertype" */ '../views/HRIS/Settings/userType'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/usermodules',
    name: 'UserModule',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "usermodule" */ '../views/HRIS/Settings/userModules'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/employeeupload',
    name: 'EmployeeUpload',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "usermodule" */ '../views/HRIS/Settings/uploademployee'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/holidays',
    name: 'Holidays',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "usermodule" */ '../views/HRIS/Settings/holidays'),
    beforeEnter: hasHRISAccess
  },
  {
    path: '/hris/settings/useraccount',
    name: 'UserAccount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "useraccount" */ '../views/HRIS/Settings/user_account'),
    beforeEnter: hasHRISAccess
  },

  {
    path: '/hris/settings/geofencing',
    name: 'GeoFencing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "geofencing */ '../views/HRIS/Settings/geofencing'),
    beforeEnter: hasHRISAccess
  },
  //TIMEKEEPING
  {
    path: '/timekeeping/dashboard',
    name: 'Timekeeping Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/DashboardPage'),
    beforeEnter: loggedIn
  },
  //EMPLOYEE FORMS
  {
    path: '/timekeeping/time-records',
    name: 'Time Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/TimekeepingRecords'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/overtime-records',
    name: 'Overtime Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/OvertimeRecords'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/leave-records',
    name: 'Leave Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/LeaveRecords'),
    beforeEnter: hasTimekeepingAccess
  },
  // {
  //   path: '/timekeeping/work-schedule',
  //   name: 'Work Schedule',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/WorkSchedule')
  // },
  {
    path: '/timekeeping/team-status',
    name: 'Team Status',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/TeamStatus'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/payslip',
    name: 'Payslip',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/PayslipPage'),
    beforeEnter: hasTimekeepingAccess
  },

  //TIMEKEEPING Approvals

  {
    path: '/timekeeping/Approval/pending-approval',
    name: 'Pending Approval',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Approvals/PendingApprovals'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Approval/alteration-history',
    name: 'Alteration History',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Approvals/AlterationHistory'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Approval/overtime-history',
    name: 'Overtime History',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Approvals/OvertimeHistory'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Approval/leave-history',
    name: 'Leave History',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Approvals/LeaveHistory'),
    beforeEnter: hasTimekeepingAccess
  },
  // {
  //   path: '/timekeeping/Approval/workschedule-history',
  //   name: 'Work Schedule History',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Approvals/WorkScheduleHistory')
  // },

    //TIMEKEEPING Reports
    // {
    //   path: '/timekeeping/Reports/daily-time-reports',
    //   name: 'Daily Time Report',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/DTR'),
    //   beforeEnter: hasTimekeepingAccess
    // },
{
    path: '/timekeeping/Reports/attendancesummary-reports',
    name: 'Attendance Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/AttendanceReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/absences-reports',
    name: 'Absences Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/AbsencesReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/leave-reports',
    name: 'Leave Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/LeaveReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/overtime-reports',
    name: 'Overtime Report', //duplicated name
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/OvertimeReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/leavebalances-reports',
    name: 'Leave Balances Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/LeaveBalancesReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/punchalteration-reports',
    name: 'Punch Alteration Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/PunchAlterationReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/frequencytardiness-reports',
    name: 'Frequency of Tardiness Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/FrequencyTardinessReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/tardiness-reports',
    name: 'Tardiness Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/TardinessReport'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/summaryleaves-reports',
    name: 'Summary of Leaves',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/SummaryLeaves'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/Reports/summarytardiness-reports',
    name: 'Summary of Tardiness',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/Reports/SummaryTardiness'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/punchalteration-records',
    name: 'Punch Alteration Records',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/PunchAlterationRecords'),
    beforeEnter: hasTimekeepingAccess
  },
  {
    path: '/timekeeping/punch-history',
    name: 'Punch History',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/PunchHistory'),
    beforeEnter: hasTimekeepingAccess
  },

  //TIMEKEEPING Admin Settings

  // {
  //   path: '/timekeeping/AdminSettings/add-alteration',
  //   name: 'Add Alteration',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/AdminSettings/AddAlteration')
  // },
  // {
  //   path: '/timekeeping/AdminSettings/add-overtime',
  //   name: 'Add Overtime',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/AdminSettings/AddOvertime')
  // },
  // {
  //   path: '/timekeeping/AdminSettings/add-leave',
  //   name: 'Add Leave',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/AdminSettings/AddLeave')
  // },
  // {
  //   path: '/timekeeping/AdminSettings/add-workschedule',
  //   name: 'Add Work Schedule',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/AdminSettings/AddWorkSchedule')
  // },
  {
    path: '/timekeeping/AdminSettings/importdownload-biometrics',
    name: 'Import/Download Biometrics',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/AdminSettings/ImportDownloadBiometrics'),
    beforeEnter: hasTimekeepingAccess
  },
  // {
  //   path: '/timekeeping/payslip-release',
  //   name: 'Payslip Release',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "timekeeping dashboard" */ '../views/TIMEKEEPING/PayslipRelease')
  // },
  {
    path: '/timekeeping/payslip-release',
    name: 'PayslipRelease',
    beforeEnter: (to, from, next) => {
      if (from.name === 'Payslip') {
        next();
      } else {
        next({ name: 'Payslip' });
      }
    },
    component: () => import('@/views/TIMEKEEPING/PayslipRelease'),
  },
  {
    path: '/timekeeping/payslip-thirteenth-release',
    name: 'ThirteenthMonthPayslipRelease',
    beforeEnter: (to, from, next) => {
      if (from.name === 'Payslip') {
        next();
      } else {
        next({ name: 'Payslip' });
      }
    },
    component: () => import('@/views/TIMEKEEPING/PayslipThirteenthMonth'),
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
